import autobind from 'autobind-decorator';
import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import {default as GradientInfo} from './gradient-info';
import GenreRow from './genre-row';

@inject('genreStore')
@observer
export default class GenreList
extends React.Component {
	render () {
		const { genreStore } = this.props;

		if (genreStore.isLoading) {

			return (<h1>Loading...</h1>);
		}

		return (
			<Fragment>
				{/* <div className="grid-x">
					<div className="cell">
						<h3 className="section-title padding-bottom-1">Genres</h3>
					</div>
				</div> */}

				<div className="grid-x">
					{
						genreStore.sortedGenreList.map((genre) => (
							<GenreRow key={ genre._id } gradientInfo={GradientInfo} { ...genre } />
						))
					}
				</div>
			</Fragment>
		);
	}
}
